import gql from 'graphql-tag';

export default {
    createUploadRequest: gql`
        mutation CreateUploadRequestV2($assetType: CreateUploadRequestAssetType!, $needsTranscoding: Boolean) {
            createUploadRequest(assetType: $assetType, needsTranscoding: $needsTranscoding) {
                __typename
                url
                parameters {
                    __typename
                    key
                    value
                }
                fileName
                fileParameterName
                httpMethod
                provider
                kind
                headers {
                    __typename
                    key
                    value
                }
            }
        }
    `,
};
